import type React from "react";
import { Paper, Grid, Typography, Divider, Box } from "@mui/material";
import { motion } from "framer-motion";
import type { IExpandedCallSheetData } from "../../../../types/callsheet";

interface ClientDetailsProps {
  callSheetData: IExpandedCallSheetData;
  reduxTheme: any;
  specialRequest: string;
}

const ClientDetails: React.FC<ClientDetailsProps> = ({
  callSheetData,
  reduxTheme,
  specialRequest,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 }}
    >
      <Paper
        elevation={0}
        sx={{
          mt: 3,
          overflow: "hidden",
          "@media print": {
            margin: 0,
            border: "none",
            boxShadow: "none",
          },
        }}
      >
        <Grid container>
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              p: 1,
              borderRight: { md: `1px solid ${reduxTheme.grey_colors[500]}` },
              borderTop: { md: `1px solid ${reduxTheme.grey_colors[500]}` },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: reduxTheme.primary_colors[400],
              }}
            >
              Client Details
            </Typography>
            <Typography sx={{ mb: 1, fontSize: "0.9rem" }}>
              <strong>Name:</strong>{" "}
              {callSheetData?.booking?.contact?.first_name || ""}{" "}
              {callSheetData?.booking?.contact?.last_name || ""}
            </Typography>
            <Typography sx={{ mb: 1, fontSize: "0.9rem" }}>
              <strong>Email:</strong>{" "}
              {callSheetData?.booking?.contact?.email || "N/A"}
            </Typography>
            <Typography sx={{ fontSize: "0.9rem" }}>
              <strong>Phone:</strong>{" "}
              {callSheetData?.booking?.contact?.phone || "N/A"}
            </Typography>
          </Grid>

          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              p: 1,
              borderTop: { md: `1px solid ${reduxTheme.grey_colors[500]}` },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: reduxTheme.primary_colors[400],
              }}
            >
              Company Details
            </Typography>
            <Typography sx={{ mb: 1, fontSize: "0.9rem" }}>
              <strong>Company:</strong>{" "}
              {callSheetData?.booking?.contact?.company_branch?.company?.name || "N/A"}
            </Typography>
            <Typography sx={{ fontSize: "0.9rem" }}>
              <strong>Address:</strong>{" "}
              {callSheetData?.booking?.contact?.company_branch?.company?.street_address || "N/A"}
            </Typography>
          </Grid>
        </Grid>

        <Divider />

        <Box
          sx={{
            p: 1,
            borderBottom: {
              md: `1px solid ${reduxTheme.grey_colors[500]}`,
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              mb: 2,
              color: reduxTheme.primary_colors[400],
            }}
          >
            Special Notes
          </Typography>
          {specialRequest && specialRequest !== "N/A" ? (
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.6, fontSize: "0.9rem" }}
            >
              {specialRequest || "N/A"}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: "0.9rem" }}
            >
              No special notes
            </Typography>
          )}
        </Box>
      </Paper>
    </motion.div>
  );
};

export default ClientDetails;
